/* tslint:disable */
/* eslint-disable */
/**
 * Citrus API Reference
 * Complete reference documentation for the Citrus API.
 *
 * The version of the OpenAPI document: 0.112.0
 * Contact: info@citruscamps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const RelationType = {
    parent: 'parent',
    grandparent: 'grandparent',
    guardian: 'guardian',
    spouse: 'spouse',
    partner: 'partner',
    sibling: 'sibling',
    friend: 'friend',
    social_worker: 'social_worker',
    self: 'self',
    other: 'other'
} as const;
export type RelationType = typeof RelationType[keyof typeof RelationType];


export function RelationTypeFromJSON(json: any): RelationType {
    return RelationTypeFromJSONTyped(json, false);
}

export function RelationTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): RelationType {
    return json as RelationType;
}

export function RelationTypeToJSON(value?: RelationType | null): any {
    return value as any;
}

